import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getOrderDetails, getRestaurantDetails } from '../../dashboard/reducer';
import {
  orderDate,
  parseStartTimeEndTime,
  getTimings,
} from '../../dashboard/actions';
import moment from 'moment';

import RadioButton from './RadioButton';
import RestaurantAvailability from './RestaurantAvailability';
import isEmpty from 'lodash/isEmpty';
import { TEXT_OPENING_SHORTLY } from '../../../util/Constants';
import { isRestaurantAvailable } from '../../../lib/helper';
import defaultMsg from '../../../translations/lang/en-US.json';

class OrderDateAndTime extends React.Component {
  constructor(props) {
    super(props);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.isValidOrderType = this.isValidOrderType.bind(this);
    this.getOrderDate = this.getOrderDate.bind(this);
    this.isNowAvialable = this.isNowAvialable.bind(this);

    const {
      isNowAvialable,
      nextDay,
      currentTimeCompare,
    } = this.isNowAvialable();
    this.state = {
      validTypes: ['pickup', 'dine-in'],
      selected: isNowAvialable ? 'now' : 'later',
      isNowAvialable: isNowAvialable,
      restaurantStatus:
        isNowAvialable === false
          ? 'This restaurant is not accepting orders at this time'
          : '',
      nextDay,
      currentTimeCompare,
    };
  }

  getCurrentDate = () => Number(moment().format('x'));

  isNowAvialable() {
    const {
      restaurantConfigurations: { hoursOfOperation, minAdvanceNoticeTime },
      maxAdvanceDays,
    } = this.props;

    const currentDate = this.getCurrentDate();
    const weekDayConfigurationForToday = parseStartTimeEndTime(
      hoursOfOperation,
      currentDate
    );

    const dayTimings = !isEmpty(weekDayConfigurationForToday)
      ? weekDayConfigurationForToday.map(config =>
          getTimings(
            minAdvanceNoticeTime,
            currentDate,
            config.starttime,
            config.endtime,
            true,
            true
          )
        )
      : [false];

    return {
      isNowAvialable: isRestaurantAvailable(hoursOfOperation),
      nextDay:
        dayTimings &&
        dayTimings.indexOf(TEXT_OPENING_SHORTLY) === -1 &&
        maxAdvanceDays === 0,
      currentTimeCompare: true,
    };
  }

  componentDidMount() {
    const {
      orderDetails: { orderDate },
      actions,
    } = this.props;
    const { isNowAvialable, nextDay, selected } = this.state;
    const orderDateTime = moment(orderDate).format('x');
  }

  getOrderDate() {
    const {
      orderDetails: { orderDate },
    } = this.props;

    if (orderDate === 'now' || !orderDate) {
      return moment().format('x');
    }
    return orderDate;
  }

  isValidOrderType() {
    const { modeOfOrder, orderTypes } = this.props;
    const { validTypes } = this.state;
    const mode = modeOfOrder.toLowerCase();
    return orderTypes.indexOf(mode) !== -1 && validTypes.indexOf(mode) !== -1;
  }

  handleRadioChange({ target: { value } }) {
    this.setOrderDate(value);
  }

  setOrderDate(value) {
    const {
      actions,
      orderDetails: { orderDate },
    } = this.props;
    this.setState({ selected: value });

    if (value === 'later') {
      actions.orderDate(Number(this.getOrderDate()));
      return;
    }
    actions.orderDate(value);
  }

  isNowCheckBoxVisible = () => {
    const { isNowAvialable } = this.state;
    return isNowAvialable;
  };

  isNowCheckBoxSelected = () => {
    const {
      orderDetails: { orderDate },
    } = this.props;
    return orderDate === 'now' || !orderDate;
  };

  isLaterCheckBoxVisible = () => {
    const { currentTimeCompare } = this.state;
    const { asapTimeAvailability, maxAdvanceDays } = this.props;
    return (
      asapTimeAvailability &&
      asapTimeAvailability === '0' &&
      (currentTimeCompare === true || maxAdvanceDays !== '0')
    );
  };

  isLaterCheckBoxSelected = () => {
    const { isNowAvialable } = this.state;
    const {
      orderDetails: { orderDate },
    } = this.props;
    return (orderDate !== 'now' && orderDate !== '') || !isNowAvialable;
  };

  render() {
    const {
      currentTimeCompare,
      nextDay,
      restaurantStatus,
      selected,
    } = this.state;
    const {
      orderDetails: { orderDate },
      asapTimeAvailability,
      intl,
      maxAdvanceDays,
    } = this.props;

    const nowRadioButton = {
      show: this.isNowCheckBoxVisible(),
      value: 'now',
      toolTipTitleID: 'tooltipAsap',
      messageID: 'ASAP',
    };
    nowRadioButton.selected =
      nowRadioButton.show && this.isNowCheckBoxSelected();

    const laterRadioButton = {
      show: this.isLaterCheckBoxVisible(),
      value: 'later',
      toolTipTitleID: 'tooltipLater',
      messageID: 'Later',
    };
    laterRadioButton.selected =
      laterRadioButton.show && this.isLaterCheckBoxSelected();

    const radioButtons = [nowRadioButton, laterRadioButton];

    //  This will fix all Production issues when loading 1st time with orderDate empty.
    //  All this component and its containers needs to be refactored to avoid patches like this one.
    if (!orderDate) {
      if (nowRadioButton.show && nowRadioButton.selected)
        this.setOrderDate(nowRadioButton.value);
      else if (laterRadioButton.show && laterRadioButton.selected) {
        this.setOrderDate(laterRadioButton.value);
      }
    }
    return (
      this.isValidOrderType() && (
        <div className="order-date-time-container">
          {radioButtons.filter(({ show }) => show).length && (
            <div className="col-lg-9 col-md-9 col-sm-9 col-xs-12 formField">
              {radioButtons.map(
                (
                  { value, selected, toolTipTitleID, messageID, show },
                  index
                ) => {
                  return (
                    show && (
                      <RadioButton
                        value={value}
                        handleRadioChange={this.handleRadioChange}
                        selected={selected}
                        message={{
                          id: messageID.toLowerCase(),
                          default: messageID,
                        }}
                        toolTipTitle={intl.formatMessage({
                          id: toolTipTitleID,
                          defaultMessage: defaultMsg[toolTipTitleID],
                        })}
                      />
                    )
                  );
                }
              )}
              {asapTimeAvailability &&
                asapTimeAvailability === '0' &&
                selected === 'later' &&
                (currentTimeCompare === true || maxAdvanceDays !== '0') && (
                  <RestaurantAvailability
                    compareDay={currentTimeCompare}
                    nextDay={nextDay}
                  />
                )}
            </div>
          )}
        </div>
      )
    );
  }
}

const mapStateToProps = state => ({
  restaurantConfigurations: getRestaurantDetails(state),
  orderDetails: getOrderDetails(state),
  asapTimeAvailability:
    state.dashboard.merchantDetails.enable_allow_asap_orders_2,
  maxAdvanceDays: state.dashboard.merchantDetails.max_advance_days_2,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      orderDate,
    },
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(OrderDateAndTime));



// WEBPACK FOOTER //
// ./src/views/checkout/components/OrderDateAndTime.jsx